import { withBaseUrl } from ".";

export const getEditorSecondLink = (key: string, src: string) => {
  let baseLink = withBaseUrl("photo-editor-app/editor/ai/" + key);
  const link = `${baseLink}?bg_url=${src}&bg_type=url`;
  return link;
};

export const getResizeImage = (url: string, width: number) => {
  return `${url}@${width}w_${width}h_1l.src`;
};
